import React from 'react';
import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from '@billda/design-system';
import { useArchiveSite } from '../../../hooks/useArchiveSite';

export interface ArchiveSiteConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  siteId: number;
}

/**
 * Confirmation dialog for archiving a site.
 * The mutation invalidates site queries, so closing on success is enough.
 */
export const ArchiveSiteConfirmDialog: React.FC<
  ArchiveSiteConfirmDialogProps
> = ({ open, onClose, siteId }) => {
  const mutation = useArchiveSite(siteId);

  const handleConfirm = () => {
    mutation.mutate(undefined, { onSuccess: onClose });
  };

  return (
    <Dialog open={open} onOpenChange={nextOpen => !nextOpen && onClose()}>
      <DialogContent>
        <DialogHeader>Archive this site?</DialogHeader>
        <DialogBody>
          It will be hidden from site lists and stop accepting new work.
          Existing records are kept.
        </DialogBody>
        <DialogFooter>
          <Button
            variant="ghost"
            onClick={onClose}
            disabled={mutation.isPending}
            data-testid="site-archive-cancel"
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            variant="danger"
            loading={mutation.isPending}
            disabled={mutation.isPending}
            data-testid="site-archive-confirm"
          >
            Archive
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
